import { adminServerInstance } from "../axios/instances.js";
import { LOGIN as type } from "./types.js";
import { execute } from "../network/executor.js";
import { useDispatch } from "react-redux";
import { showAlertSnackbar } from "../reducers/uiSlice.js";

export const userLogin = (username, password) => (dispatch) => execute(dispatch)(
  adminServerInstance.post(`/map/login?username=${username}`, {
    password: password,
  }),
  {
    type: type.USER_LOGIN,
    success: type.USER_LOGIN_SUCCESS,
    fail: type.USER_LOGIN_FAIL,
  }
);

export const userLogout = () => {
  window.localStorage.removeItem('auth_token');
  window.localStorage.removeItem('username');
  window.localStorage.removeItem('user_level');
  window.localStorage.removeItem('user_city');
  window.localStorage.removeItem('user_id');
  window.localStorage.removeItem('branches');
  window.localStorage.removeItem('districts');

  window.location.reload();
};

export const authUpdate = () => {
  window.localStorage.setItem('auth_update_open', 1);
  const event = new Event('storageChange', {detail: window.localStorage.getItem('auth_update_open')});
  window.dispatchEvent(event);
};